import React from 'react';
import { bool, func, string } from 'prop-types';

import './page-heading.m.css';

const PageHeading = ({
  showResultsFor = false,
  title,
  bio,
  smallHeading = '',
  hasStories = false,
  count = 0,
  viewmore,
  showmore
}) => {
  const headingWithResult = !showResultsFor ? null : (
    <span styleName="page_heading_result__result-for"> Results for </span>
  );

  title = title?.split(' ');
  const [firstname, ...lastname] = title;
  return title ? (
    <div styleName="page_heading_result">
      <h1
        styleName={`page_heading_result__heading ${
          showResultsFor ? 'reduce-page-heading-line-height' : ''
        }`}
      >
        {headingWithResult}
        <span
          styleName={`page_heading_result__title ${
            smallHeading ? 'page_heading_result__title--small' : ''
          } ${!hasStories ? 'page_heading_result__title--center' : ''} ${
            showResultsFor ? 'page_heading_result__title--search' : ''
          }`}
        >
          {firstname}
          <span styleName="page_heading_result__title--light">{` ${lastname.join(' ')}`}</span>
        </span>
      </h1>
      {bio && (
        <p
          styleName="page_heading_result__title--center"
          style={{ margin: '0', color: 'gray', marginBottom: '10px' }}
        >
          {bio}
          <span style={{ color: 'red', cursor: 'pointer' }} onClick={viewmore}>
            {bio?.length > 129 && `${showmore ? ' less' : ' more'}`}
          </span>
        </p>
      )}
      {count > 0 ? <span styleName="stories-count">{count} Stories</span> : null}
    </div>
  ) : null;
};

PageHeading.propTypes = {
  showResultsFor: bool,
  title: string,
  smallHeading: string,
  hasStories: bool,
  count: string,
  bio: string,
  viewmore: func,
  showmore: bool
};

export { PageHeading };
